<template>
    <div class="menu">
        <div class="logo-box">
            <img src="../assets/logo.png" class="logo">
        </div>
        <div class="menu-box">
            <div class="item" :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">{{ $t('menu_1') }} </div>
            <div class="item" :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">{{ $t('menu_2') }}</div>
            <div class="item" :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">{{ $t('menu_3') }}</div>
            <div class="item" :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">{{ $t('menu_4') }}</div>
            <div class="show_list">
                <span>Language</span>
                <ul class="move_list">
                    <li @click="$i18n.locale = 'en'">English</li>
                    <li @click="$i18n.locale = 'br'">Portugués</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "Game" }); break;
                default: this.$router.push({ path: "Privacy" }); break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.menu {
    padding: 10px 300px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-box {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
    }

    .logo {
        // width: 242px;
        height: 30px;
        margin-right: 10px;
    }

    .menu-box {
        display: flex;
        width: 600px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #00858B;
        cursor: pointer;

        .item {
            padding: 0px 10px;
        }
    }

    .select {
        color: #E51359;
    }

    .show_list {
        position: relative;

        .move_list {
            display: none;
            position: absolute;
        }

        &:hover {
            .move_list {
                display: block;
            }
        }
    }
}
</style>